<template>
    <base-component :taxpayerInfo="currentTaxpayer">
        <template slot="form">
            <money-placement-search-form :fetch="fetchData" :taxpayerInfo="currentTaxpayer || $route.params" :pageSize="pageSize" :offset="offset" :setOffset="setOffset"/>
        </template>
        <template slot="createButton">
            <b-button v-if="!showCreateDialog && canCreate" @click="openCreateModal()" variant="primary">
                <plus-icon title="" />&nbsp;{{ $t('general.create') }}
            </b-button>
        </template>
        <template slot="createForm">
            <create-form v-if="showCreateDialog" :taxpayer="currentTaxpayer || $route.params" :onClose="closeCreateModal"/>
        </template>
        <template slot="workArea">
            <b-alert variant="danger" :show="showAlert">
                {{ alert }}
            </b-alert>
            <b-card no-body class="flex-fill flex-shrink-0">
                <b-tabs card>
                    <b-tab :title="$t('menu.kkms')" @click="openKkms"></b-tab>
                    <b-tab v-if="!isInspector" :title="$t('menu.blockedKkms')" @click="openBlockedKkms"></b-tab>
                    <b-tab :title="$t('menu.reports')" @click="openReports"></b-tab>
                    <b-tab :title="$t('menu.tickets')" @click="openTickets"></b-tab>
                    <b-tab :title="$t('menu.moneyPlacements')" active>
                        <pagination :pageSize="this.pageSize" :offset="offset" :listLength="moneyPlacements.length" :setOffset="setOffset"/>
                        <b-table :items="moneyPlacements" :fields="fields" class="table-borderless" striped small show-empty>
                            <template slot="txnClientDate" slot-scope="row">
                                {{ $d(row.item.txnClientDate, 'long') }}
                            </template>
                            <template slot="debet" slot-scope="row">
                                {{ row.item.debet ? $t('moneyPlacement.collection') : $t('moneyPlacement.replenishment') }}
                            </template>
                            <template slot="actions" slot-scope="row">
                                <b-dropdown variant="link">
                                    <template slot="button-content">
                                        <dots-icon title="" />
                                    </template>
                                    <b-dd-item v-if="isTaxpayer" target="_blank" :to="{ name: 'moneyPlacementDetails', params: row.item }">{{ $t('general.details') }}</b-dd-item>
                                    <b-dd-item v-else target="_blank" :to="{ name: 'childMoneyPlacementDetails', params: row.item }">{{ $t('general.details') }}</b-dd-item>
                                </b-dropdown>
                            </template>
                            <template slot="empty">
                                <div class="text-center">
                                    {{ $t('general.noData') }}
                                </div>
                            </template>
                        </b-table>
                    </b-tab>
                    <b-tab v-if="!isOperator" :title="$t('menu.tasks')" @click="openTasks"/>
                </b-tabs>
            </b-card>
        </template>
    </base-component>
</template>

<script>
/* eslint-disable */
import AppData from '@/utils/appdata'
const MoneyPlacementSearchForm = () => import(/* webpackChunkName: "chunk-views" */ '@/components/moneyplacement/MoneyPlacementSearchForm.vue')
const CreateForm = () => import(/* webpackChunkName: "chunk-views" */ '@/components/moneyplacement/MoneyPlacementCreateForm.vue')
const Pagination = () => import(/* webpackChunkName: "chunk-views" */ '@/components/general/Pagination.vue')

export default {
    name: 'MoneyPlacement',
    mixins: [ AppData ],
    components: {
        MoneyPlacementSearchForm,
        CreateForm,
        Pagination
    },
    data () {
        return {
            moneyPlacements: [],
            showCreateDialog: false,
            pageSize: 20,
            offset: 0
        }
    },
    mounted () {
        this.getCurrentTaxpayer()
    },
    computed: {
        fields: function () {
            return [
                { key: 'ccmFactoryNumber', label: this.$t('moneyPlacement.kkmFactoryNum'), sortable: true },
                { key: 'shiftNumber', label: this.$t('moneyPlacement.shiftNumber'), sortable: true },
                { key: 'shiftDocumentNumber', label: this.$t('moneyPlacement.shiftDocumentNumber'), sortable: true },
                { key: 'txnClientDate', label: this.$t('moneyPlacement.txnClientDate'), sortable: true },
                { key: 'debet', label: this.$t('moneyPlacement.debet') },
                { key: 'amount', label: this.$t('moneyPlacement.amount') },
                { key: 'actions', label: this.$t('general.actions') }
            ]
        },
        canCreate() {
            const role = this.$store.getters.getUserRole; 
            
            return role === this.$appConfig.role.operator || role === this.$appConfig.role.dealer; 
        }
    },
    methods: {
        fetchData: function (formData) {
            this.hideAlert()
            if (this.offset === 0) {
                formData.txnClientEndDate = formData.txnClientEndDateForm
            }

            const onSuccess = response => {
                this.moneyPlacements = [];

                if (!Array.isArray(response))
                    throw new Error('Server must be returns array');
                
                for(let mp of response){
                    if(mp.txnClientDate != null)
                        mp.txnClientDate = new Date(mp.txnClientDate);
                    
                    this.moneyPlacements.push(mp);
                }
                    
                if (this.offset === 0 && this.moneyPlacements[0] != null){
                    formData.txnClientEndDate = this.moneyPlacements[0].txnClientDate;
                    formData.txnClientEndDate.setMilliseconds(formData.txnClientEndDate.getMilliseconds() + 1);
                }
            };

            this.$request.sendRequest(
                this,
                this.$appConfig.apiUrls.moneyPlacement.get,
                formData, 
                onSuccess,
                this.displayAlert);
        },
        setOffset: function (newValue) {
            this.offset = newValue
        },
        openKkms: function () {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'kkms' })
            } else {
                this.$router.push({ name: 'childKkm' })
            }
        },
        openReports: function () {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'reports' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childReports' })
            }
        },
        openTickets: function () {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'tickets' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childTickets' })
            }
        },
        openBlockedKkms: function () {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'kkmsBlocked' })
            } else if (this.isOperator) {
                this.$router.push({ name: 'blockedKkms' })
            }
        },
        openCreateModal() {
            this.showCreateDialog = true;
        },
        closeCreateModal() {
            this.showCreateDialog = false;
        },
        openTasks() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'tasks' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childTasks' })
            }
        }
    }
}
</script>
